import React, { useEffect, useState } from "react";
// @material-ui/core components
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { Redirect } from "react-router-dom";
import { getRedirectUrl } from "utils";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import eightAxios from "configs/axiosConfig";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import { USER_PROFILE_VIEW } from "configs/constants";
import { useTranslation } from "react-i18next";

import avatar from "assets/img/faces/marc.jpg";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "Montserrat",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

const useStyles = makeStyles(styles);

export default function UserProfile() {
  const { t } = useTranslation();
  const initialValues = {};
  const classes = useStyles();
  // eslint-disable-next-line
  const [results, setResults] = useState(initialValues);
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);
  const [redirect, setRedirect] = useState(false);

  const getUserProfile = () => {
    setLoading(true);
    eightAxios
      .get(USER_PROFILE_VIEW)
      .then((response) => {
        setResults(response.data);
        console.log(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const handleBackClick = () => {
    setRedirect(true);
  };

  useEffect(() => {
    getUserProfile();
  }, []);

  useEffect(() => {
    try {
      let moNum = results.mobile_number;
      if (moNum.startsWith("60")) {
        setMobile(moNum);
      } else {
        moNum = "60" + moNum;
        setMobile(moNum);
      }
    } catch {
      console.log("");
    }
  }, [results]);

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  if (redirect) {
    let redirectUrl = getRedirectUrl();
    if (redirectUrl) return <Redirect to={redirectUrl} />;
    // return <Redirect to="/" />;
  }

  return (
    <div>
      <Card lg={12}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={8}>
            <Card style={{ marginLeft: 15 }}>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>
                  {" "}
                  {t("Employment Details")}
                </h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={5}>
                    <CustomInput
                      label={t("Designation")}
                      defaultValue={results.designation}
                      id="zone"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        readOnly: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                    <CustomInput
                      label={t("Department")}
                      defaultValue={results.department}
                      id="region"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        readOnly: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                    <CustomInput
                      label={t("Office Number")}
                      defaultValue={results.office_number}
                      id="estate"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        readOnly: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={5}>
                    <CustomInput
                      label={t("Zone")}
                      defaultValue={results.zone_name}
                      id="zone"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        readOnly: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                    <CustomInput
                      label={t("Region")}
                      defaultValue={results.region_name}
                      id="region"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        readOnly: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                    <CustomInput
                      label={t("Estate")}
                      defaultValue={results.estate_name}
                      id="estate"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        readOnly: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={5}>
                    <CustomInput
                      label={t("Division")}
                      defaultValue={results.division_name}
                      id="division"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        readOnly: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                    <CustomInput
                      label={t("Block")}
                      defaultValue={results.block_name}
                      id="block"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        readOnly: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <Grid style={{ marginTop: 20 }} item lg={2}>
                  <Button
                    style={{
                      textTransform: "capitalize",
                      borderRadius: 0,
                    }}
                    type="cancel"
                    variant="contained"
                    color="primary"
                    onClick={handleBackClick}
                    fullWidth
                  >
                    Back
                  </Button>
                </Grid>
              </CardBody>
              <CardFooter></CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <Card profile>
              <CardAvatar profile>
                <a href="#pablo" onClick={(e) => e.preventDefault()}>
                  <img src={avatar} alt="..." />
                </a>
              </CardAvatar>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>
                  {t("Personal Details")}
                </h4>
              </CardHeader>
              <CardBody profile>
                <GridItem>
                  <CustomInput
                    label={t("Employee Id")}
                    defaultValue={results.employee_id}
                    id="employee_id"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      readOnly: true,
                    }}
                  />
                </GridItem>
                <GridItem>
                  <CustomInput
                    label={t("Name")}
                    defaultValue={results.name}
                    id="name"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      readOnly: true,
                    }}
                  />
                </GridItem>
                <GridItem>
                  <CustomInput
                    label={t("Email")}
                    defaultValue={results.email}
                    id="email"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      readOnly: true,
                    }}
                  />
                </GridItem>
                <GridItem>
                  <CustomInput
                    label={t("Role")}
                    defaultValue={results.role_name}
                    id="role"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      readOnly: true,
                    }}
                  />
                </GridItem>
                <GridItem>
                  <CustomInput
                    label={t("Mobile Number")}
                    defaultValue={mobile}
                    id="mobile_number"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      readOnly: true,
                    }}
                  />
                </GridItem>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </Card>
    </div>
  );
}
